import chunk from 'lodash.chunk';
import React, { useState } from 'react';

import { scrollElementToCenterX } from 'utils/js';

import { Body, Container, Header, Language, LanguageList } from './styles';

type PropTypes = {
  children: Array<React.ReactElement>;
};

const TabbedExamples = ({ children }: PropTypes): JSX.Element => {
  const [currentExample, setCurrentExample] = useState(0);

  const nodes = React.useMemo(() => {
    const childrenArray = React.Children.toArray(children);
    return chunk(childrenArray, 2);
  }, [children]);

  const currentComponent = nodes[currentExample];

  return (
    <Container>
      <Header>
        <LanguageList>
          {nodes.map(([label], index) => {
            const active = index === currentExample;

            return (
              <Language
                key={index.toString()}
                active={active}
                type="button"
                data-testid={`change-language-${index}`}
                onClick={(event): void => {
                  setCurrentExample(index);
                  scrollElementToCenterX(event.currentTarget);
                }}
              >
                {label}
              </Language>
            );
          })}
        </LanguageList>
      </Header>
      <Body>{currentComponent[1]}</Body>
    </Container>
  );
};

export default TabbedExamples;
